module.exports = "./assets/assets/相关政策依据.1ffb70e2.docx";